import { render, staticRenderFns } from "./chevronRight.vue?vue&type=template&id=dcbb3494"
import script from "./chevronRight.vue?vue&type=script&lang=js"
export * from "./chevronRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports